// extracted by mini-css-extract-plugin
export var bodyRow = "_cp-d";
export var cardColumns = "_cp-e";
export var ellipsesOverflow = "_cp-2";
export var flatBottomCorners = "_cp-3";
export var flatTopCorners = "_cp-4";
export var headerActionsDropdown = "_cp-f";
export var headerBottomRow = "_cp-c";
export var headerTopRow = "_cp-b";
export var orderDetailsWrapper = "_cp-0";
export var orderInfoContainer = "_cp-1";
export var productDetails = "_cp-9";
export var productImage = "_cp-5";
export var responsiveTable = "_cp-8";
export var shipmentContainer = "_cp-a";
export var tableBottomLeft = "_cp-6";
export var tableBottomRight = "_cp-7";
export var trackingLink = "_cp-g";